import { createSlice } from '@reduxjs/toolkit';
import {
  AddNotificationPayloadType,
  INotificationsState,
  SetNotificationsPayloadType,
} from './types';

const initialState: INotificationsState = {
  notifications: [],
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications(state, action: SetNotificationsPayloadType) {
      state.notifications = action.payload;
    },
    addNotification(state, action: AddNotificationPayloadType) {
      state.notifications.unshift(action.payload);
    },
  },
});

export const { addNotification, setNotifications } = notificationsSlice.actions;
export const notificationsReducer = notificationsSlice.reducer;
